import Violation from './Violation'
import { requestAPI } from '../../data/api'
import Image from '../../Image'
import React, { useState, useEffect } from 'react'

export default function PhotoWithViolations(props) {
	const {
		violation,
		proxyPermissionLevel,
		email,
		markRemainingViolationsAsNotViolating,
		onCachedActionChange,
	} = props
	const [multiCases, setMultiCases] = useState([])

	useEffect(() => {
		const findMultiCases = async (domain) => {
			try {
				const data = await requestAPI(`/domains?name=${domain}`, 'GET')
				if (!data.domains.length) return
				setMultiCases(data.domains)
			} catch (err) {
				console.error(err)
			}
		}
		if (!violation.domain) return
		findMultiCases(violation.domain)
	}, [violation])

	return (
		<div className='row violations-image'>
			<div
				className='col-md-3'
				style={{
					position: 'sticky',
					top: '15px',
				}}
			>
				<h3
					style={{
						marginTop: 0,
						marginBottom: '10px',
						fontSize: '1.1em',
						fontWeight: '600',
					}}
				>
					Original Image
				</h3>
				<Image photo={violation} width='100%' className='image' />
				<div>
					<p>Image ID: {violation.name}</p>
					<p>Photographer Name: {violation.photographer_name}</p>
					<p>Client: {violation.short_name}</p>
				</div>
			</div>
			<div className='col-md-9'>
				<div>
					<Violation
						key={violation.violation_id}
						violation={violation}
						proxyPermissionLevel={proxyPermissionLevel}
						email={email}
						multiCase={multiCases.find((el) => el.domain === violation.domain)}
						markRemainingViolationsAsNotViolating={
							markRemainingViolationsAsNotViolating
						}
						onCachedActionChange={onCachedActionChange}
					/>
				</div>
			</div>
		</div>
	)
}
